import { formatPointLabel } from "../../base/utils";
import { ChartSelectValueFormatKind, DisplayValueType } from "store/current-dashboard/types";
const getFormattedValue = (displayValueType, point, total, currency, displayKind) => {
    if (displayValueType === DisplayValueType.Percent) {
        return formatPointLabel(point.y / total, ChartSelectValueFormatKind.percent, "", { currency, maximumFractionDigits: 1 });
    }
    else if (displayKind === ChartSelectValueFormatKind.amount) {
        return formatPointLabel(point.y, ChartSelectValueFormatKind.amount, "", { currency });
    }
    return formatPointLabel(point.y, displayKind || ChartSelectValueFormatKind.value, "", { currency, maximumFractionDigits: 0 });
};
export const formatToolTip = (widgetProps, point, selectedDropDownProps, displayKind, currency, total, displayValueType) => {
    const value = getFormattedValue(displayValueType, point, total, currency, displayKind);
    return widgetProps.tooltipKeys
        ? widgetProps.tooltipKeys.map((tooltipKey, index) => {
            switch (index) {
                case 0:
                    return [selectedDropDownProps[parseInt(tooltipKey.slice(1), 10)]?.displayName, point.key];
                case 1:
                    return [tooltipKey, point.series.name];
                case 2:
                    return [selectedDropDownProps[parseInt(tooltipKey.slice(1), 10)]?.displayName, value];
                default:
                    return ["", ""];
            }
        })
        : [["", ""]];
};
